module.exports = {
    type: ['object', 'null'],
    additionalProperties: false,
    properties: {
        typeId: {
            type: 'string'
        },
        id: {
            type: 'string'
        },
        version: {
            type: 'number'
        }
    }
};